export const mfRoutes = [
  {
    path: '/about/:slug/',
    name: 'about-content',
    component: () => import('@/pages/about-content/ui/AboutContentPage.vue'),
  },
];

export default mfRoutes;
